import React from "react";
import * as hs from "@hlibs/react/hstyles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Toolbar from "@mui/material/Toolbar";
// import { Box } from "@hlibs/react-web/components";
// import BaseLayout from "@hlibs/react-web/layouts/BaseLayout";

const defaultProps = {
  // maxWidth: 1600,
  maxHeight: null,
  // minWidth: 600,
  minHeight: null,
};

const defaultStyles = {};

const HeaderFooterMainLayout = (props) => {
  const mergedProps = hs.mergeProps(defaultProps, props);

  // const styles = hs.mergeStyles(defaultStyles, mergedProps.style);

  const { children, header, footer } = mergedProps;
  const drawerWidth = 260;
  return (
    <Box sx={{ display: "flex" }}>
      {header}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "row",
          width: {
            xs: `calc(100% - ${drawerWidth}px)`,
            sm: `calc(100% - ${drawerWidth}px)`,
            md: `calc(100% - ${drawerWidth}px)`,
            lg: `calc(100% - ${drawerWidth}px)`,
            xl: `calc(100% - ${drawerWidth}px)`,
          },
        }}
      >
        <Box
          sx={{
            pl: { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 },
            pr: { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 },
            pt: { xl: 5, lg: 5, md: 4, sm: 4, xs: 2 },
            mr: { xl: 3, lg: 3, md: 0, sm: 0, xs: 0 },
            ml: { xl: 3, lg: 3, md: 0, sm: 0, xs: 0 },
            width: "100%",
          }}
        >
          <Toolbar />
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default HeaderFooterMainLayout;
